import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import Card from '@material-ui/core/Card';
import { createStructuredSelector } from 'reselect';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Field, reduxForm, change, touch } from 'redux-form';
import { Box, Typography } from '@material-ui/core';
import classNames from 'classnames';
import styles from './styles';
import { closeModal } from '../../store/actions/modal';
import Button from '../Button';

import { updateBusinessAttributes } from '../../store/actions/userProfile';
import { USER_PROFILE_TYPES, VIEWABLE_FORM_MODES } from '../../constants';
import {
  selectIsUpdatingBusinessProfile,
  selectBusinessProfileFormMode,
  selectModalIsOpen,
} from '../../store/selectors';
import JsonPlaceSearchFormField from '../../fields/reduxForm/JsonPlacesSearchFormField';
import { required } from '../../utilities/validators';

const propTypes = {
  onUpdateBusinessAttributes: PropTypes.func,
  onCloseModal: PropTypes.func,
  classes: PropTypes.object,
  businessNumber: PropTypes.string,
  isUpdatingBusinessProfile: PropTypes.bool.isRequired,
  businessProfileFormMode: PropTypes.oneOf([
    VIEWABLE_FORM_MODES.EDITING,
    VIEWABLE_FORM_MODES.VIEWING,
  ]).isRequired,

  handleSubmit: PropTypes.func.isRequired, // from redux-form
  submitting: PropTypes.bool.isRequired, // from redux-form
  pristine: PropTypes.bool.isRequired, // from redux-form
  changeFieldValue: PropTypes.func.isRequired, // from redux-form
  touchField: PropTypes.func.isRequired, // from redux-form
};

const defaultProps = {};

const MaterialLocationModal = props => {
  const {
    onUpdateBusinessAttributes,
    classes,
    businessNumber,
    isUpdatingBusinessProfile,
    businessProfileFormMode,
  } = props;
  // console.log(
  //   '🚀 ~ file: index.js ~ line 41 ~ businessProfileFormMode',
  //   businessProfileFormMode,
  // );
  const [value, setValue] = useState(null);
  if (businessProfileFormMode === VIEWABLE_FORM_MODES.VIEWING && value) {
    window.location = '/';
  }
  const {
    handleSubmit,
    pristine,
    submitting,
    changeFieldValue,
    touchField,
    onCloseModal,
  } = props;
  const handleGettingCoord = latLong => {
    setValue(`${latLong}`);
    changeFieldValue('coordinates', `${latLong.lat}, ${latLong.lng}`);
  };
  const handleClearCoord = () => {
    changeFieldValue('coordinates', '');
  };
  const handleServiceAreaChange = () => {
    touchField('coordinates');
  };
  return (
    <Dialog open maxWidth="md" fullWidth onClose={onCloseModal}>
      <Card className={classes.cardRoot}>
        <div
          container
          justify="space-between"
          // classes={{
          //   root: classes.cardHeaderRoot,
          //   title: classes.cardHeaderTitle,
          // }}
          className={classNames(
            classes.cardHeaderRoot,
            classes.cardHeaderTitle,
            classes.flexContainer,
          )}
          title=""
        >
          <Typography display="inline" className={classes.itemCenter}>
            Business Details
          </Typography>
          <div className={classes.itemRight}>
            <Button
              variant="contained"
              color="primary"
              display="inline"
              onClick={() => {
                localStorage.setItem('skipMaterialLocation', true);
                window.location = '/';
              }}
            >
              Remind Me Later
            </Button>
          </div>
        </div>
        <CardContent
          classes={{
            root: classes.cardContentRoot,
          }}
        >
          <form onSubmit={handleSubmit}>
            <Grid container alignItems="center" mt="2">
              <Grid item xs={12}>
                <Field
                  name="materialLocation"
                  label="Where do you plan to purchase James Hardie products for your next project?"
                  component={JsonPlaceSearchFormField}
                  props={{
                    onGettingCoord: handleGettingCoord,
                    onClearCoord: handleClearCoord,
                    onFieldBlur: handleServiceAreaChange,
                  }}
                  validate={[required]}
                />
              </Grid>
              {/* <Grid item xs={12} alignContent="center" mt={2}>
                <Field
                  name="coordinates"
                  component={HiddenTextField}
                  props={{
                    id: 'service-area-coord-text-field',
                    fullWidth: true,
                  }}
                  validate={[coordRequired]}
                />
              </Grid> */}
              <Grid xs={12} justify="center" container mt={4}>
                <Box mt={6}>
                  <Button
                    className={classes.button}
                    type="submit"
                    disabled={pristine || submitting}
                    variant="contained"
                    color="primary"
                    fullWidth={false}
                    onClick={handleSubmit(values => {
                      onUpdateBusinessAttributes(
                        localStorage.getItem('accessToken'),
                        USER_PROFILE_TYPES.BUSINESS,
                        {
                          materialLocation: values.materialLocation,
                          businessNumber,
                        },
                      );
                    })}
                  >
                    {isUpdatingBusinessProfile && (
                      <CircularProgress size={20} />
                    )}
                    {!isUpdatingBusinessProfile && 'Submit'}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </Dialog>
  );
};

MaterialLocationModal.propTypes = propTypes;
MaterialLocationModal.defaultProps = defaultProps;

const mapDispatchToProps = dispatch => ({
  onCloseModal: () => dispatch(closeModal()),
  onUpdateBusinessAttributes: (accessToken, profileType, businessAttributes) =>
    dispatch(
      updateBusinessAttributes(accessToken, profileType, businessAttributes),
    ),
  changeFieldValue: (field, value) =>
    dispatch(change('MaterialLocationForm', field, value)),
  touchField: (field, value) =>
    dispatch(touch('MaterialLocationForm', field, value)),
});

const mapStateToProps = createStructuredSelector({
  isUpdatingBusinessProfile: selectIsUpdatingBusinessProfile(),
  businessProfileFormMode: selectBusinessProfileFormMode(),
  isModalOpen: selectModalIsOpen(),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(
    reduxForm({
      form: 'MaterialLocationForm',
    })(MaterialLocationModal),
  ),
);
